export default __webpack_public_path__ + "static/media/IMG_5988 copie.bee99c83.jpg";